import React, { useState, useEffect } from "react";
import { DialogContent, TextField, InputLabel, Grid } from "@mui/material";
import useStyles from "../../../globalStyles";
import BootstrapDialog from "../../../components/dialog";
import DialogHeader from "../../../components/dialog/dialogHeader";
import DialogFooter from "../../../components/dialog/dialogFooter";
import axios from "axios";
import FileSaver from "file-saver";
import { getAllCourses } from "../../../services/admin/courses/Courses";
import { baseUrl } from "../../../services";
import { ToWords } from "to-words";
import moment from "moment";
import { updateStudentById } from "../../../services/members/studentRegistartion/StudentRegistartion";
export default function RefundDialog({
  type,
  open,
  dialogData,
  refund,
  isLoading,
  refundBy,
  totalCourseFees,
  courseName,
  handleClose,
  setOpenDialog,
  handleSnackbarVal,
  handleGetAllStudentsByBatch,
  setFeesPaid,
  setIsLoading,
  setRefundBy,
  setRefund,
}) {
  const classes = useStyles();
  useEffect(() => {
    if (dialogData) {
      setRefund(0);
      setRefundBy(dialogData?.refundBy);
    }
  }, [dialogData]);

  const handleBtn = () => {
    if (refund < 0) {
      handleSnackbarVal(true, "error", `Amount can not be less than 0`);
    } else if (refundBy == "") {
      handleSnackbarVal(true, "error", `Name is required`);
    } else if (parseInt(refund) > parseInt(dialogData.feesPaid)) {
      handleSnackbarVal(
        true,
        "error",
        `Refund amount can not be greater than fees amount `
      );
    } else {
      let payload = {
        feesPaid: parseInt(dialogData.feesPaid) - parseInt(refund),
        refundBy: refundBy,
        refund: refund,
      };
      setIsLoading(true);
      updateStudentById(dialogData?._id, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.status == 200) {
            handleClose();
            getAllCourses();
            handleSnackbarVal(true, "success", response.data.message);
            handleGetAllStudentsByBatch();
            const toWords = new ToWords();
            let words = toWords.convert(response?.data?.data?.feesPaid);
            const newDate = moment(new Date()).format("DD-MM-YY");
            axios
              .post(`${baseUrl}createPdf`, {
                totalFees: totalCourseFees,
                feesPaid: response?.data?.data?.feesPaid,
                discount: response?.data?.data?.discount,
                courseName: courseName,
                words: words,
                date: newDate,
                currentPaid: refund,
                type: "refund",
                name: response?.data?.data?.name,
              })
              .then((res) => {
                axios
                  .get(`${baseUrl}fetchPdf`, { responseType: "blob" })
                  .then((response) => {
                    const pdfBlob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    FileSaver.saveAs(pdfBlob, `${dialogData?.name}`);
                  })
                  .then((res) => {})
                  .catch(() => {
                    setIsLoading(false);
                  });

                axios
                  .post(`${baseUrl}/sendPdf`, {
                    email: dialogData.email,
                    courseName: courseName,
                    type: "refund",
                    currentPaid: refund,
                  })
                  .then((resultfinal) => {
                    setIsLoading(false);
                  })
                  .catch(() => {
                    setIsLoading(false);
                  });
              })
              .catch((err) => {
                setIsLoading(false);
                handleSnackbarVal(true, "error", err?.message);
              });
          } else {
            handleSnackbarVal(true, "error", response.data.message);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div>
      <BootstrapDialog onClose={handleClose} open={open}>
        <DialogHeader title={"Refund Fees"} handleClose={handleClose} />
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputLabel className={classes.globalInputLabel}>
                Refund Amount
              </InputLabel>
              <TextField
                autoFocus
                placeholder="Refund Amount"
                variant="outlined"
                size="small"
                className={classes.globalInput}
                type="number"
                value={refund}
                onChange={(e) => setRefund(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel className={classes.globalInputLabel}>
                Refund By
              </InputLabel>
              <TextField
                autoFocus
                placeholder="Refund By"
                variant="outlined"
                size="small"
                className={classes.globalInput}
                type="text"
                value={refundBy}
                onChange={(e) => setRefundBy(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogFooter
          type={type}
          handleUpdate={handleBtn}
          handleClose={handleClose}
        />
      </BootstrapDialog>
    </div>
  );
}
